import { render, staticRenderFns } from "./FooterLazy.vue?vue&type=template&id=22d4f4de"
import script from "./FooterLazy.vue?vue&type=script&lang=js"
export * from "./FooterLazy.vue?vue&type=script&lang=js"
import style0 from "./FooterLazy.vue?vue&type=style&index=0&id=22d4f4de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports